export const BalanceHours = {
  "Saldo total acumulado": "Saldo total acumulado",
  "Saldo de horas no período acumulado": "Saldo de horas no período acumulado",
  "Data": "Data",
  "Horas necessárias": "Horas necessárias",
  "Horas trabalhadas": "Horas trabalhadas",
  "Saldo": "Saldo",
  "Pode conter fatores multiplicações nas horas extras aplicadas. Qualquer dúvida, verifique com seu gestor.": "Pode conter fatores de multiplicação nas horas extraordinárias aplicadas. Em caso de dúvida, verifique com o seu gestor.",
  "Saldo de horas": "Saldo de horas",
  "Últimos 30 dias": "Últimos 30 dias",
  "tooltip_update": "A última atualização de dados foi feita no dia {date}. Para atualizar novamente, clique aqui."
};


// WEBPACK FOOTER //
// ./src/resources/ptPT/BalanceHours.js